import React from "react";
import { Link } from "react-router-dom";
import logo from "@assets/svgs/logo_white.svg";
import styles from "./styles/NotificationHeader.module.css";
import { useSelector } from "react-redux";
import { ADMIN_ROLE } from "@constants";

const NotificationHeader = () => {
  const { login } = useSelector((state) => state.auth);
  return (
    <div className={styles.header}>
      <Link to={login.role === ADMIN_ROLE ? "/admin" : "/"}>
        <img src={logo} alt="logo" height={32} width={135} />
      </Link>
    </div>
  );
};

/* required: display name */
NotificationHeader.displayName = "NotificationHeader";

/* required: props types */
NotificationHeader.propTypes = {};

/* required: default props */
NotificationHeader.defaultProps = {};

export { NotificationHeader };
